import { StatusbarComponent } from './status-bar/status-bar.component';

export const Components = [
	StatusbarComponent,
];
